import { filter } from 'rxjs/operators';
import { FarmersDetailsService } from './../../../services/farmers-details.service';
import { Component, EventEmitter, OnInit, Output, OnDestroy ,Input} from '@angular/core';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { Observable, Subject, first } from 'rxjs';
import { FormBuilder, FormGroup } from '@angular/forms';
import { JEService } from 'src/app/services/je-services.service';
import { MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { JsonPipe } from '@angular/common';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';

@Component({
  selector: 'app-attachment',
  templateUrl: './attachment.component.html',
  styleUrls: ['./attachment.component.scss']
})
export class AttachmentComponent implements OnInit, OnDestroy {
  // if(sessionStorage.getItem('userRole')=='DD Associate'){
    
  // }
  
  @Input() data:any
  uploadOptions: any[];
  selectedCity1: any;
  displayCameraComponent: boolean = false;
  remarks: String;
  items: any[];
  selectedStatus: any;
  isDDAssociate:any;
  // images = [{
  //   source: 'https://via.placeholder.com/301.jpg',
  //   alt: 'Alt1',
  //   title: 'Title1'
  // }, {
  //   source: 'https://via.placeholder.com/302.jpg',
  //   alt: 'Alt2',
  //   title: 'Title2'
  // }, {
  //   source: 'https://via.placeholder.com/303.jpg',
  //   alt: 'Alt3',
  //   title: 'Title3'
  // },
  // {
  //   source: 'https://via.placeholder.com/301.jpg',
  //   alt: 'Alt1',
  //   title: 'Title1'
  // }, {
  //   source: 'https://via.placeholder.com/302.jpg',
  //   alt: 'Alt2',
  //   title: 'Title2'
  // }, {
  //   source: 'https://via.placeholder.com/303.jpg',
  //   alt: 'Alt3',
  //   title: 'Title3'
  // }];
  images = [];

  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5
    },
    {
      breakpoint: '768px',
      numVisible: 3
    },
    {
      breakpoint: '560px',
      numVisible: 1
    }
  ];

  // Camera 
  @Output()
  public pictureTaken = new EventEmitter<WebcamImage>();

  // toggle webcam on/off
  public showWebcam = true;
  public allowCameraSwitch = true;
  public multipleWebcamsAvailable = false;
  public deviceId!: string;
  public webcamImage!: WebcamImage;
  public videoOptions: MediaTrackConstraints = {
    width: { ideal: this.viewportToPixels('100vw') },
    height: { ideal: 500 },
  };
  public imageCaptured = false;
  public errors: WebcamInitError[] = [];
  autoId: any;
  miPhysicalAppReqBody: any;
  appId: any;
  editBilledData: boolean = false;

  viewportToPixels(value) {
    var parts = value.match(/([0-9\.]+)(vh|vw)/)
    var q = Number(parts[1])
    var side = window[['innerHeight', 'innerWidth'][['vh', 'vw'].indexOf(parts[2])]]
    return side * (q / 100)
  }


  // webcam snapshot trigger
  private trigger: Subject<void> = new Subject<void>();
  // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
  private nextWebcam: Subject<boolean | string> = new Subject<boolean | string>();
  selctedFileType: any;
  applicationNo: any;
  documentList: any = [];
  displayCustom: boolean;
  displayCustomJE: boolean;
  displayCustomXEN: boolean;
  activeIndex: number = 0;
  ParamsAppID: any;
  jeLogin: any
  jeorxenLogin: any
  xenLogin: any
  miPhysicalApplicationData: any;
  showListImageJE: boolean = true;
  showListImageXEN: boolean = true;

  listImagePathJE: any;
  listImagePathXEN: any;

  userID: any;

  constructor(private _personalDetalSer: FarmersDetailsService, private _fb: FormBuilder, private jeService: JEService, private messageService: MessageService, private route: ActivatedRoute, private router: Router, private cryptoJsService: CryptoJsService, private deptDashBoardService: DepartmentDashboardService,private loader: AppLoaderService, private activityRecordService: ActivityRecordService) {
    this.uploadOptions = [
      { name: 'Team and Farmer', code: 'team_and_farmer' },
      { name: 'Field Photo', code: 'field_photo' },
      { name: 'Component Photo', code: 'component_photo' },
      { name: 'Farmers Acceptance', code: 'farmers_acceptance' },
      { name: 'Others', code: 'others' }
    ];
    const tokenData = sessionStorage.getItem('token') ? JSON.parse(sessionStorage.getItem('token')) : {}
    if(tokenData && (tokenData.role == 'JE' || tokenData.role == 'CJE')){ 
      this.jeLogin = true
      this.jeorxenLogin = true
    }
    if(tokenData && (tokenData.role == 'XEN' || tokenData.role == 'CXEN')){ 
      this.xenLogin = true
     this.jeorxenLogin = true
    }
    this.route.queryParams
    .subscribe(params => {
      this.ParamsAppID = params.appId
    })
  }
  ngOnDestroy(): void {
    this.displayCameraComponent = false;
  }

  ngOnInit(): void {
    console.log(this.data,"data")
    if (sessionStorage.getItem(this.cryptoJsService.Encrypt('editBilledData'))) {
      this.editBilledData = Boolean(this.cryptoJsService.DecryptData(sessionStorage.getItem(this.cryptoJsService.Encrypt('editBilledData'))));
    }
    if(sessionStorage.getItem('userRole')=='DD Associate'){
      this.isDDAssociate=true
      this.appId=this.data.appId
      this.autoId=this.data.autoId
      if (this.appId) {
        if (JSON.parse(sessionStorage.getItem('documentList'))?.appId == this.appId) {
          this.documentList = JSON.parse(sessionStorage.getItem('documentList'))?.documentList;
        }
        if ((JSON.parse(sessionStorage.getItem('miPhysicalAppReqBody'))?.length)) {
          if ((JSON.parse(sessionStorage.getItem('miPhysicalAppReqBody'))[0]?.appID) == this.appId) {
            this.miPhysicalAppReqBody = JSON.parse(sessionStorage.getItem('miPhysicalAppReqBody'));
          } else {
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Please Save Finace Data to continue!' });
            // setTimeout(() => {
            //   this.router.navigate([this.router.url.split('/')[1], 'application', 'finance'], { queryParams: { autoId: params.autoId, appId: params.appId } });
            //   return;
            // }, 1000);
          }

        } else {
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Please Save Finace Data to continue!' });
          // setTimeout(() => {
          //   this.router.navigate([this.router.url.split('/')[1], 'application', 'finance'], { queryParams: { autoId: params.autoId, appId: params.appId } });
          //   return;
          // }, 1000);
        }

      } else {
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! AutoID cant be empty' });
        return;
      }
    }
    else{
      this.isDDAssociate=false
      this.route.queryParams
      .subscribe(params => {
        this.autoId = this.cryptoJsService.DecryptData(params.autoId);
        this.appId = this.cryptoJsService.DecryptData(params.appId);
        if (this.appId) {
          if (JSON.parse(sessionStorage.getItem('documentList'))?.appId == this.appId) {
            this.documentList = JSON.parse(sessionStorage.getItem('documentList'))?.documentList;
          }
          if ((JSON.parse(sessionStorage.getItem('miPhysicalAppReqBody'))?.length)) {
            if ((JSON.parse(sessionStorage.getItem('miPhysicalAppReqBody'))[0]?.appID) == this.appId) {
              this.miPhysicalAppReqBody = JSON.parse(sessionStorage.getItem('miPhysicalAppReqBody'));
            } else {
              this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Please Save Finace Data to continue!' });
              // setTimeout(() => {
              //   this.router.navigate([this.router.url.split('/')[1], 'application', 'finance'], { queryParams: { autoId: params.autoId, appId: params.appId } });
              //   return;
              // }, 1000);
            }

          } else {
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Please Save Finace Data to continue!' });
            setTimeout(() => {
              this.router.navigate([this.router.url.split('/')[1], 'application', 'finance'], { queryParams: { autoId: params.autoId, appId: params.appId } });
              return;
            }, 1000);
          }

        } else {
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! AutoID cant be empty' });
          return;
        }
      }
      );
    }

    

      this.miPhysicalApplicationData = JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'));
      console.log("miPhysicalApplicationData", this.miPhysicalApplicationData);
      

      if(this.miPhysicalApplicationData?.listDataForPhysicalVer){ 
        for (let index = 0; index < this.miPhysicalApplicationData?.listDataForPhysicalVer.length; index++) {
          if(this.miPhysicalApplicationData.listDataForPhysicalVer[index].inventory!=null && this.miPhysicalApplicationData.listDataForPhysicalVer[index].inventory.length>0){
            delete this.miPhysicalApplicationData.listDataForPhysicalVer[index].selectedQuantity;
            delete this.miPhysicalApplicationData.listDataForPhysicalVer[index].selectedInventory;
          }
        }        
      }
      if(sessionStorage.getItem('isJE')){
        this.showListImageJE = false;
        this.showListImageXEN = false;
        this.documentList = JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'))?.listImagePathJE;
      }
      else if(sessionStorage.getItem('isXEN')){
        this.showListImageXEN = false;
        this.listImagePathJE = JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'))?.listImagePathJE
        this.documentList = JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'))?.listImagePathXEN;
      }
      else{
        this.listImagePathJE = JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'))?.listImagePathJE;
        this.listImagePathXEN = JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'))?.listImagePathXEN;
      }

    WebcamUtil.getAvailableVideoInputs()
      .then((mediaDevices: MediaDeviceInfo[]) => {
        this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
      });

    let sessionToken = sessionStorage.getItem('token');
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;
    let actionId;
    if((this.router.url.split('/')[1] == 'department') || (this.router.url.split('/')[1] == 'admin')){
      actionId = 19; // Do not Change, it is fixed for Farmer Application Verifications
    }else{
      actionId = 18; // Do not Change, it is fixed for Farmer Application Verifications
    }
    this.loader.start();
    this.deptDashBoardService
      .GetStatusMaster(JSON.parse(payload)?.sub, actionId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          this.items = data.$values;
        },
        error: () => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Status Master cant be Loaded',
          });
        },
      });
  }

  goBack() {

  }

  onAttachmentDetailsFormSubmit() {
    this.images = this.documentList;
    console.log('Image List', this.images);
    console.log('Document List', this.documentList);
    let isValid = true;
    // if ((this.images && this.images.length == 0) && this.jeLogin) {
    //   if (this.documentList.length == 0) {
    //     this.messageService.add({ severity: 'error', summary: 'Error Message1', detail: 'Images are Mandatory' });
    //     return;
    //   } else {
    //     this.uploadOptions.forEach(option => {
    //       if (option.code != 'others') {

    //         let filtered = this.documentList.filter(doc => { 
    //           return doc.document_type == option.code 
    //         });
    //         console.log('filtered', filtered)
    //         if (filtered?.length == 0) {
    //           this.messageService.add({ severity: 'error', summary: 'Error Message11', detail: 'Atleast one ' + option.name + ' is Needed!' });
    //           isValid = false;
    //           return;
    //         }
    //       }
    //     });
    //   }
    //   if (!isValid) {
    //     return;
    //   }
    // } else {
    //   if (this.images.length == 0) {
    //     this.messageService.add({ severity: 'error', summary: 'Error Message2', detail: 'Images are Mandatory' });
    //     return;
    //   } else {
    //     this.uploadOptions.forEach(option => {
    //       if (option.name != 'Others') {
    //         let filtered = this.images.filter(doc => { 
    //           console.log('ELSE',doc.DocumentType == option.name)
    //           return doc.DocumentType == option.name 
    //         });
    //         if (filtered?.length == 0) {
    //           this.messageService.add({ severity: 'error', summary: 'Error Message22', detail: 'Atleast one ' + option.name + ' is Needed!' });
    //           isValid = false;
    //           return;
    //         }
    //       }
    //     });
    //   }
    //   if (!isValid) {
    //     return;
    //   }
    // }

    // console.log((this.images && this.images.length == 0) && this.jeLogin, "HELLLOOO", this.jeLogin, )
    if (this.jeLogin || (this.xenLogin && sessionStorage.getItem('myPhysicalSurveyType') == '1')) {
      if (this.documentList.length == 0) {
        this.messageService.add({ severity: 'error', summary: 'Error Message1', detail: 'Images are Mandatory' });
        return;
      } 
      else {
        this.uploadOptions.forEach(option => {
          if (option.code != 'others') {

            let filtered = this.documentList.filter(doc => { 
              return doc.DocumentType == option.code 
            });
            console.log('filtered', filtered)
            if (filtered?.length == 0) {
              this.messageService.add({ severity: 'error', summary: 'Error Message11', detail: 'Atleast one ' + option.name + ' is Needed!' });
              isValid = false;
              return;
            }
          }
        });
      }
      if (!isValid) {
        return;
      }
    }
    // return;
    if(sessionStorage.getItem('userRole')=='DD Associate'){
      if (this.autoId) {
        let body = [];

        // Note : Only newly captured images has to be sent for the API
        //populating the newly captured images
        this.documentList.forEach(document => {
          body.push({
            "attachmentsDoc": document?.attachment ? document?.attachment : document?.ImagePath,
            "documentType": document?.DocumentType,
          })
        })          

        this.miPhysicalAppReqBody[0].insertServayAttachments = body;
        this.miPhysicalAppReqBody[0].remarks = this.remarks ? this.remarks : '';
        this.miPhysicalAppReqBody[0].status = this.selectedStatus.flag;
        let reqBody = this.miPhysicalAppReqBody;

        //Remove 'componentDetail' & 'insertServayAttachments' for department & ADMIN login
        if((this.router.url.split('/')[1] == 'department') || (this.router.url.split('/')[1] == 'admin')){
          this.miPhysicalAppReqBody[0].componentDetail = undefined;
          this.miPhysicalAppReqBody[0].insertServayAttachments = undefined;
          reqBody = this.miPhysicalAppReqBody[0];
        }
        this.loader.start();
        this.jeService.insertPhysicalVerification(reqBody).pipe(first())
          .subscribe({
            next: (data) => {
              this.loader.close();
              if (data == 'S:Successfully Submitted') {
                sessionStorage.removeItem('documentList');
                sessionStorage.removeItem('miPhysicalAppJEGPSCoordinates');
                sessionStorage.removeItem('miPhysicalAppXENGPSCoordinates');
                sessionStorage.removeItem('myPhysicalSurveyType')
                this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Successfully Submitted' });
                setTimeout(() => {
                  this.router.navigate([this.router.url.split('/')[1], 'physical-verification']);
                }, 1000);
              } else if (data == 'S:Successfully Updated') {
                sessionStorage.removeItem('documentList');
                sessionStorage.removeItem('miPhysicalAppJEGPSCoordinates');
                sessionStorage.removeItem('miPhysicalAppXENGPSCoordinates');
                sessionStorage.removeItem('myPhysicalSurveyType')
                this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Successfully Updated' });
                setTimeout(() => {
                  this.router.navigate([this.router.url.split('/')[1], 'physical-verification']);
                }, 1000);
              }
              else {
                this.messageService.add({ severity: 'error', summary: 'Error Message', detail: data.toString() });
              }
              this.activityRecordService.activityRecord(this.userID, 'MI Physical Verification Action Submit', reqBody[0]?.appID, new Date(), data, reqBody[0]);

            },
            error: (err) => {
              this.activityRecordService.activityRecord(this.userID, 'MI Physical Verification Action Submit', reqBody[0]?.appID, new Date(), err, reqBody[0]);
              this.loader.close();
              this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Physical Applications not uploaded.' });
            }
          });
      } else {
        this.loader.close();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! AutoID cant be Empty' });
      }
    }
    else{
      this.route.queryParams
      .subscribe(params => {
        if (params.autoId) {
          let body = [];

          // Note : Only newly captured images has to be sent for the API
          //populating the newly captured images
          this.documentList.forEach(document => {
            body.push({
              "attachmentsDoc": document?.attachment ? document?.attachment : document?.ImagePath,
              "documentType": document?.DocumentType,
            })
          })          

          this.miPhysicalAppReqBody[0].insertServayAttachments = body;
          this.miPhysicalAppReqBody[0].remarks = this.remarks ? this.remarks : '';
          this.miPhysicalAppReqBody[0].status = this.selectedStatus.flag;
          let reqBody = this.miPhysicalAppReqBody;

          //Remove 'componentDetail' & 'insertServayAttachments' for department & ADMIN login
          if((this.router.url.split('/')[1] == 'department') || (this.router.url.split('/')[1] == 'admin')){
            this.miPhysicalAppReqBody[0].componentDetail = undefined;
            this.miPhysicalAppReqBody[0].insertServayAttachments = undefined;
            reqBody = this.miPhysicalAppReqBody[0];
          }
          this.loader.start();
          this.jeService.insertPhysicalVerification(reqBody).pipe(first())
            .subscribe({
              next: (data) => {
                this.loader.close();
                if (data == 'S:Successfully Submitted') {
                  sessionStorage.removeItem('documentList');
                  sessionStorage.removeItem('miPhysicalAppJEGPSCoordinates');
                  sessionStorage.removeItem('miPhysicalAppXENGPSCoordinates');
                  sessionStorage.removeItem('myPhysicalSurveyType')
                  this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Successfully Submitted' });
                  setTimeout(() => {
                    this.router.navigate([this.router.url.split('/')[1], 'physical-verification']);
                  }, 1000);
                } else if (data == 'S:Successfully Updated') {
                  sessionStorage.removeItem('documentList');
                  sessionStorage.removeItem('miPhysicalAppJEGPSCoordinates');
                  sessionStorage.removeItem('miPhysicalAppXENGPSCoordinates');
                  sessionStorage.removeItem('myPhysicalSurveyType')
                  this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Successfully Updated' });
                  setTimeout(() => {
                    this.router.navigate([this.router.url.split('/')[1], 'physical-verification']);
                  }, 1000);
                }
                else {
                  this.messageService.add({ severity: 'error', summary: 'Error Message', detail: data.toString() });
                }
                this.activityRecordService.activityRecord(this.userID, 'MI Physical Verification Action Submit', reqBody[0]?.appID, new Date(), data, reqBody[0]);

              },
              error: (err) => {
                this.activityRecordService.activityRecord(this.userID, 'MI Physical Verification Action Submit', reqBody[0]?.appID, new Date(), err, reqBody[0]);
                this.loader.close();
                this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Physical Applications not uploaded.' });
              }
            });
        } else {
          this.loader.close();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! AutoID cant be Empty' });
        }
      }
      );
    }
    
  }

  openCamera() {
    this.displayCameraComponent = true;
  }

  onCloseDialog() {
    this.displayCameraComponent = false;
  }

  //Camera
  public triggerSnapshot(): void {
    this.trigger.next();
  }

  public toggleWebcam(): void {
    this.showWebcam = !this.showWebcam;
  }

  public handleInitError(error: WebcamInitError): void {
    this.errors.push(error);
  }

  public showNextWebcam(directionOrDeviceId: boolean | string): void {
    // true => move forward through devices
    // false => move backwards through devices
    // string => move to device with given deviceId
    this.nextWebcam.next(directionOrDeviceId);
  }

  public handleImage(webcamImage: WebcamImage): void {
    // console.info('received webcam image', webcamImage);
    this.webcamImage = webcamImage;
    this.imageCaptured = true;
    this.pictureTaken.emit(webcamImage);
  }

  public cameraWasSwitched(deviceId: string): void {
    // console.log('active device: ' + deviceId);
    this.deviceId = deviceId;
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public get nextWebcamObservable(): Observable<boolean | string> {
    return this.nextWebcam.asObservable();
  }

  public uploadPicture() {
    const arr = this.webcamImage.imageAsDataUrl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const file: File = new File([u8arr], this.selctedFileType + '.jpeg', { type: mime })
    let data = new FormData();
    data.append('file', file);
    let sessionToken = sessionStorage.getItem('token');
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    let phNo = (JSON.parse(payload)?.sub).trim();
    if(sessionStorage.getItem('userRole')=='DD Associate'){
      if (this.autoId) {
        this._personalDetalSer
          .uploadFile(data, phNo, this.selctedFileType.code)
          .subscribe((resp: any) => {
            if (resp.statusCode == 200) {
              this.documentList.push({
                attachment: resp.data,
                attachmentRawUrl: this.webcamImage.imageAsDataUrl,
                DocumentType: this.selctedFileType.code,
                displayName: this.cryptoJsService.DecryptData(this.appId) + '_',
                name:
                  this.selctedFileType.code === 'team_and_farmer'
                    ? 'team_and_farmer'
                    : this.selctedFileType.code === 'field_photo'
                      ? 'field_photo'
                      : this.selctedFileType.code === 'farmers_acceptance'
                        ? 'farmers_acceptance'
                        : this.selctedFileType.code === 'others'
                          ? 'others'
                          : 'Component Photo',
                isUploaded: false,
              });

              let documentListObject = {
                'appId': this.cryptoJsService.DecryptData(this.appId),
                'documentList': this.documentList
              }
              sessionStorage.setItem('documentList', JSON.stringify(documentListObject));
              this.selctedFileType = '';
              this.retake();
              this.displayCameraComponent = false;
            } else {
              console.log('Error');
            }
            this.selctedFileType = '';
          });

      } else {
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! AutoID cant be Empty' });
      }
    }
    else{
      this.route.queryParams
      .subscribe(params => {
        if (params.autoId) {
          this._personalDetalSer
            .uploadFile(data, phNo, this.selctedFileType.code)
            .subscribe((resp: any) => {
              if (resp.statusCode == 200) {
                this.documentList.push({
                  attachment: resp.data,
                  attachmentRawUrl: this.webcamImage.imageAsDataUrl,
                  DocumentType: this.selctedFileType.code,
                  displayName: this.cryptoJsService.DecryptData(params.appId) + '_',
                  name:
                    this.selctedFileType.code === 'team_and_farmer'
                      ? 'team_and_farmer'
                      : this.selctedFileType.code === 'field_photo'
                        ? 'field_photo'
                        : this.selctedFileType.code === 'farmers_acceptance'
                          ? 'farmers_acceptance'
                          : this.selctedFileType.code === 'others'
                            ? 'others'
                            : 'Component Photo',
                  isUploaded: false,
                });

                let documentListObject = {
                  'appId': this.cryptoJsService.DecryptData(params.appId),
                  'documentList': this.documentList
                }
                sessionStorage.setItem('documentList', JSON.stringify(documentListObject));
                this.selctedFileType = '';
                this.retake();
                this.displayCameraComponent = false;
              } else {
                console.log('Error');
              }
              this.selctedFileType = '';
            });

        } else {
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! AutoID cant be Empty' });
        }
      }
      );
    }
    
  }

  retake() {
    this.imageCaptured = false;
  }

  onAttachmentsFormGoBack() {
    this.route.queryParams
      .subscribe(params => {
        if (params.autoId) {
          this.router.navigate([this.router.url.split('/')[1], 'application', 'finance'], { queryParams: { autoId: params.autoId, appId: params.appId } });
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! AutoID cant be Empty' });
        }
      }
      );
  }

  // imageClick(index: number) {
  //   this.activeIndex = index;
  //   this.displayCustom = true;
  // }

  imageClick(index: number, type) {
    this.activeIndex = index;
    if(type == "JE"){
      this.displayCustomJE = true;
    }
    else if(type == "XEN"){
      this.displayCustomXEN = true;
    }
    else if(type == "PA"){
      this.displayCustom = true;
    }
  }

  removeCaptureImg(i){
    this.documentList.splice(i, 1)
    let documentListObject = {
      'appId': this.cryptoJsService.DecryptData(this.ParamsAppID),
      'documentList': this.documentList
    }
    sessionStorage.setItem('documentList', JSON.stringify(documentListObject));
    console.log(i, '*****')
  }

}
